import script from './panel-date-range.vue_vue_type_script_lang.mjs';
export { default } from './panel-date-range.vue_vue_type_script_lang.mjs';
import { render } from './panel-date-range.vue_vue_type_template_id_62b45ab2_lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/panel-date-range.vue";
//# sourceMappingURL=panel-date-range.mjs.map
